import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { copyDraft, Draft } from '@app/store/transport-layer/form/drafts/copy';

import { queryKeyPrefix } from '../useDrafts';

export default function useCopyDraft(
  options?: UseMutationOptions<Draft, Error, { workspaceId: string; id: string }>
) {
  const queryClient = useQueryClient();
  return useMutation(({ workspaceId, id }) => copyDraft(workspaceId, id), {
    ...options,
    onSuccess: (data, variables, ctx) => {
      queryClient.invalidateQueries(queryKeyPrefix);
      options?.onSuccess?.(data, variables, ctx);
    },
  });
}
